import request from '@/utils/request'



export function logout() {
  return request({
    url: '/kxuser/user/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/kxuser/user/list',
    method: 'get',
    params: params
  })
}

//当前单位用户列表
export function getCompanyAndAccountInfoList(params) {
  return request({
    url:'kxuser/user/getCompanyAndAccountInfoList',
    method: 'get',
    params: params
  })
}

//当前单位绑定用户
export function bindUserAndCompanyRelationInfo(data) {
  return request({
    url: 'kxuser/user/bindUserAndCompanyRelationInfo',
    method: 'post',
    data: data
  })
}

//当前单位解绑用户
export function deleteCompanyAndAccountInfoById(id,data){
  return request({
    url: 'kxuser/user/deleteCompanyAndAccountInfoById/'+id,
    method: 'delete',
    data: data
  }) 
}

export function createuser(data) {
  return request({
    url: '/user/register',
    method: 'post',
    data: data
  })
}

//修改用户
export function updateuser(id, data) {
  return request({
    url: '/kxuser/user/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/kxuser/user/updateStatus/' + id,
    method: 'post',
    params: params
  })
}


export function deleteuser(id) {
  return request({
    url: '/kxuser/user/delete/' + id,
    method: 'post'
  })
}

//用户绑定角色
export function allocRole(data) {
  return request({
    url: '/kxuser/user/role/update',
    method: 'post',
    data: data
  })
}

//当前用户角色
export function getRoleByAdmin(id) {
  return request({
    url: '/kxuser/user/role/' + id,
    method: 'get'
  })
}


//当前用户购买权限
export function updatecompany(data) {
  return request({
    url: '/kxuser/user/update/company/',
    method: 'post',
    data: data
  })
}

//用户类别
export function getCompanyType(params) {
  return request({
    url: '/kxuser/new_role/getCompanyType1/seller_type',
    method: 'get',
    params: params
  })
}



//用户头像上传
export function uploadUserAvatar(data) {
  return request({
    url: '/kxuser/user/uploadUserAvatar/user',
    method: 'post',
    data: data,
    headers: {
      "Content-Type": "multipart/form-data;charset=utf-8"
    },
  })
}


//大厅开票
export function querySupplierHzid(params) {
  return request({
    url: '/kxuser/user/querySupplierHzid',
    method: 'get',
    params: params
  })
}


//大厅开票
export function getKPDZ(id,params) {
  return request({
    url: '/kxuser/user/getKPDZ/'+id,
    method: 'get',
    params: params
  })
}

//供应商添加
export function newPromoters(data) {
  return request({
    url: '/kxuser/userAdmin/newPromoters/',
    method: 'post',
    data: data
  })
}

//货架号打印
export function barcodeList(params) {
  return request({
    url: '/kxgoods/barcode/data',
    method: 'get',
    params: params
  })
}



//无单位会员删除
export function removeUserInfoById(id) {
  return request({
    url: '/kxuser/user/removeUserInfoById/'+id,
    method: 'delete',
  })
}


//操作记录
export function querySystemLogList(params) {
  return request({
    url: '/kxuser/new_role/querySystemLogList',
    method: 'get',
    params: params
  })
}


//当前用单位收货地址列表
export function getAddressList(params) {
  return request({
    url: '/kxuser/address/list/',
    method: 'get',
    params:params
  })
}



//添加收货地址
export function createAddress(data) {
  return request({
    url: '/kxuser/address/create/',
    method: 'post',
    data: data
  })
}



//修改收货地址
export function updateAddress(id,data) {
  return request({
    url: '/kxuser/address/update/'+id,
    method: 'post',
    data: data
  })
}


//省市区列表
export function getAreaList(params) {
  return request({
    url: '/kxuser/area/listAll/',
    method: 'get',
    params:params
  })
}


//修改默认地址状态
export function updateAddressStatus(data) {
  return request({
    url: '/kxuser/address/updateAddressStatus/',
    method: 'put',
    data: data
  })
}


//删除收货地址
export function deleteAddress(id) {
  return request({
    url: '/kxuser/address/delete/'+id,
    method: 'delete',
  })
}




//设置用为为业务员
export function updateSalerLevel(data) {
  return request({
    url: '/kxuser/saler/updateSalerLevel/',
    method: 'put',
    data: data
  })
}

export function getCompanyAccountByCompanyId(params){
  return request({
    url: 'kxuser/bankAccount/getCompanyAccountByCompanyId.do/-1',
    method: 'get',
    params: params
  })
}

//查询自定义价格客户列表
export function getCustomerUsePriceInfo(params) {
  return request({
    url: '/kxuser/user/getCustomerUsePriceInfo',
    method: 'get',
    params: params
  })
}

//新建自定义价格客户
export function addCustomerUsePriceInfo (data) {
  return request({
    url: '/kxuser/user/addCustomerUsePriceInfo/',
    method: 'post',
    data: data
  })
}

//删除自定义价格客户
export function deleteCustomerUsePriceInfo (data, id) {
  return request({
    url: '/kxuser/user/deleteCustomerUsePriceInfo/'+id,
    method: 'delete',
    data: data
  })
}

//根据colname获取字典
export function getBasedictByColname(type, params) {
  return request({
    url: '/kxuser/new_role/getCompanyType1/'+type,
    method: 'get',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js